import TransactionDetail from "./Payment/modals/TransactionDetail";
import EditAccountInfo from "./Account/modals/EditAccountInfo";
import { selectLogOutModal } from "../../store/auth/selectors";
import VideoPlayer from "./JobsHistory/modals/VideoPlayer";
import LogOut from "../../containers/LogOut";
import PersonalEmailWarning from "../../containers/PersonalEmailWarning";
import { selectPersonalEmailWarningModal } from "../../store/signUp/selectors";
import AddExtraApplicant from "./Account/modals/AddExtraApplicant";
import AddExtraJobPost from "./Account/modals/AddExtraJobPost";
import ExaminerReport from "./JobsHistory/modals/ExaminerReport";
import RecruitingInterviewReport from "./JobsHistory/modals/RecruitingInterviewReport";
import ContactSales from "./Payment/modals/ContactSales";
import ConfirmCancelSubscription from "./Payment/modals/ConfirmCancelSubscription";
import JobDetail from "./JobsHistory/modals/JobDetail";
import ChangePassword from "./Account/modals/ChangePassword";
import InviteMember from "./Account/modals/InviteMember";
import ConfirmLeaveOrganization from "./Account/modals/ConfirmLeaveOrganization";
import ConfirmJoinOrganization from "./Account/modals/ConfirmJoinOrganization";
import ConfirmRemoveMember from "./Account/modals/ConfirmRemoveMember";
import AddExtraMember from "./Account/modals/AddExtraMember";
import ExtraServicesPayment from "./Account/modals/ExtraServicesPayment";
import EditJobExamDeadline from "./JobsHistory/modals/EditJobExamDeadline";
import CopyJobLinkWarning from "../../containers/CopyJobLinkWarning";
import VideoUploadIssue from "./JobsHistory/modals/VideoUploadIssue";
import PreparingExams from "../../containers/PreparingExams";
import ContactAdmin from "../../containers/ContactAdmin";
import ExamShareGuide from "../../containers/ExamShareGuide";
import EditPhoneNumber from "./Account/modals/EditPhoneNumber";
import EditCompanyInfo from "./Account/modals/EditCompanyInfo";
import ChangePlan from "./Account/modals/ChangePlan";
import IncompleteProfile from "../../containers/IncompleteProfile";
import UploadCompanyLogo from "./Account/modals/UploadCompanyLogo";
import ExaminerProfile from "./JobsHistory/modals/ExaminerProfile";
import AddNewCard from "./Payment/modals/AddNewCard";
import ConfirmEndExam from "./JobsHistory/modals/ConfirmEndExam";
import WorkspaceLayout from "../../layouts/Workspace";
import { useDispatch, useSelector } from "../../store/store";
import DeleteCard from "./Payment/modals/DeleteCard";
import EditCard from "./Payment/modals/EditCard";
import PurchasePlan from "./Payment/modals/PurchasePlan";
import PlansModal from "./Payment/modals/PlansModal";
import EditEmail from "./Account/modals/EditEmail";
import ChooseCard from "./Payment/modals/ChooseCard";
import { getUserInfoThunk } from "../../store/auth/thunks";
import { Outlet } from 'react-router-dom';
import { useEffect } from "react";
import {
    getJobsThunk,
    getLogoImageThunk,
    getProfileDataThunk,
    getUserAttributesThunk,
    getStripeCustomerThunk,
} from "../../store/workspace/thunks";
import {
    selectProfile,
    selectEditCardModal,
    selectPlansModalShow,
    selectAddNewCardModal,
    selectDeleteCardModal,
    selectChangePlanModal,
    selectCompanyLogoModal,
    selectPurchasePlanModal,
    selectConfirmEndExamModal,
    selectEditAccountInfoModal,
    selectExaminerProfileModal,
    selectEditCompanyInfoModal,
    selectTransactionDetailModal,
    selectIncompleteProfileModal,
    selectChooseCreditCardModalModal,
    selectVideoPlayerModal,
    selectExaminerReportModal,
    selectRecruitingInterviewReportModal,
    selectContactSalesModal,
    selectConfirmCancelSubscriptionModal,
    selectJobDetailModal,
    selectChangePasswordModal,
    selectInviteMemberModal,
    selectConfirmJoinOrganizationModal,
    selectConfirmRemoveMemberModal,
    selectContactAdminModal,
    selectExamShareGuideModal,
    selectEditPhoneNumberModal,
    selectConfirmLeaveOrganizationModal,
    selectEditEmailModal,
    selectAddExtraApplicantModal,
    selectAddExtraJobPostModal,
    selectAddExtraMemberModal,
    selectExtraServicesPaymentModal,
    selectEditJobExamDeadlineModal,
    selectPreparingExamsModal,
    selectCopyJobLinkWarningModal,
    selectVideoUploadIssueModal,
} from "../../store/workspace/selectors";

function Workspace() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const logOutModal = useSelector(selectLogOutModal);
    const editCardModal = useSelector(selectEditCardModal);
    const plansModalShow = useSelector(selectPlansModalShow);
    const jobDetailModal = useSelector(selectJobDetailModal);
    const editEmailModal = useSelector(selectEditEmailModal);
    const addNewCardModal = useSelector(selectAddNewCardModal);
    const deleteCardModal = useSelector(selectDeleteCardModal);
    const changePlanModal = useSelector(selectChangePlanModal);
    const companyLogoModal = useSelector(selectCompanyLogoModal);
    const videoPlayerModal = useSelector(selectVideoPlayerModal);
    const contactSalesModal = useSelector(selectContactSalesModal);
    const purchasePlanModal = useSelector(selectPurchasePlanModal);
    const inviteMemberModal = useSelector(selectInviteMemberModal);
    const contactAdminModal = useSelector(selectContactAdminModal);
    const confirmEndExamModal = useSelector(selectConfirmEndExamModal);
    const examinerReportModal = useSelector(selectExaminerReportModal);
    const examShareGuideModal = useSelector(selectExamShareGuideModal);
    const changePasswordModal = useSelector(selectChangePasswordModal);
    const addExtraMemberModal = useSelector(selectAddExtraMemberModal);
    const preparingExamsModal = useSelector(selectPreparingExamsModal);
    const editPhoneNumberModal = useSelector(selectEditPhoneNumberModal);
    const examinerProfileModal = useSelector(selectExaminerProfileModal);
    const editAccountInfoModal = useSelector(selectEditAccountInfoModal);
    const editCompanyInfoModal = useSelector(selectEditCompanyInfoModal);
    const addExtraJobPostModal = useSelector(selectAddExtraJobPostModal);
    const videoUploadIssueModal = useSelector(selectVideoUploadIssueModal);
    const addExtraApplicantModal = useSelector(selectAddExtraApplicantModal);
    const incompleteProfileModal = useSelector(selectIncompleteProfileModal);
    const transactionDetailModal = useSelector(selectTransactionDetailModal);
    const copyJobLinkWarningModal = useSelector(selectCopyJobLinkWarningModal);
    const chooseCreditCardModal = useSelector(selectChooseCreditCardModalModal);
    const editJobExamDeadlineModal = useSelector(selectEditJobExamDeadlineModal);
    const confirmRemoveMemberModal = useSelector(selectConfirmRemoveMemberModal);
    const extraServicesPaymentModal = useSelector(selectExtraServicesPaymentModal);
    const personalEmailWarningModal = useSelector(selectPersonalEmailWarningModal);
    const confirmJoinOrganizationModal = useSelector(selectConfirmJoinOrganizationModal);
    const confirmLeaveOrganizationModal = useSelector(selectConfirmLeaveOrganizationModal);
    const recruitingInterviewReportModal = useSelector(selectRecruitingInterviewReportModal);
    const confirmCancelSubscriptionModal = useSelector(selectConfirmCancelSubscriptionModal);

    useEffect(() => {
        if (!profile?.companyLogo) return;
        dispatch(getLogoImageThunk(profile.companyLogo));
    }, [profile]);

    useEffect(() => {
        dispatch(getJobsThunk({}));
        dispatch(getUserInfoThunk());
        dispatch(getProfileDataThunk());
        dispatch(getUserAttributesThunk());
        dispatch(getStripeCustomerThunk({ action: 'get_customer' }))
    }, []);

    return (
        <WorkspaceLayout>
            <Outlet />
            {logOutModal && <LogOut />}
            {editCardModal && <EditCard />}
            {editEmailModal && <EditEmail />}
            {jobDetailModal && <JobDetail />}
            {plansModalShow && <PlansModal />}
            {deleteCardModal && <DeleteCard />}
            {changePlanModal && <ChangePlan />}
            {videoPlayerModal && <VideoPlayer />}
            {purchasePlanModal && <PurchasePlan />}
            {inviteMemberModal && <InviteMember />}
            {contactSalesModal && <ContactSales />}
            {contactAdminModal && <ContactAdmin />}
            {chooseCreditCardModal && <ChooseCard />}
            {preparingExamsModal && <PreparingExams />}
            {addExtraMemberModal && <AddExtraMember />}
            {examinerReportModal && <ExaminerReport />}
            {changePasswordModal && <ChangePassword />}
            {examShareGuideModal && <ExamShareGuide />}
            {confirmEndExamModal && <ConfirmEndExam />}
            {companyLogoModal && <UploadCompanyLogo />}
            {editCompanyInfoModal && <EditCompanyInfo />}
            {editAccountInfoModal && <EditAccountInfo />}
            {examinerProfileModal && <ExaminerProfile />}
            {editPhoneNumberModal && <EditPhoneNumber />}
            {addExtraJobPostModal && <AddExtraJobPost />}
            {videoUploadIssueModal && <VideoUploadIssue />}
            {addExtraApplicantModal && <AddExtraApplicant />}
            {transactionDetailModal && <TransactionDetail />}
            {incompleteProfileModal && <IncompleteProfile />}
            {copyJobLinkWarningModal && <CopyJobLinkWarning />}
            {editJobExamDeadlineModal && <EditJobExamDeadline />}
            {confirmRemoveMemberModal && <ConfirmRemoveMember />}
            {extraServicesPaymentModal && <ExtraServicesPayment />}
            {personalEmailWarningModal && <PersonalEmailWarning />}
            {confirmJoinOrganizationModal && <ConfirmJoinOrganization />}
            {confirmLeaveOrganizationModal && <ConfirmLeaveOrganization />}
            {confirmCancelSubscriptionModal && <ConfirmCancelSubscription />}
            {recruitingInterviewReportModal && <RecruitingInterviewReport />}
            {addNewCardModal && <AddNewCard />}
        </WorkspaceLayout>
    );
};

export default Workspace;
